<!-- results-table.component.html -->
<h1 mat-dialog-title>
    <strong>Eliminar </strong> formulario
    <span> {{ LOCAL_DATA.nombreCompleto }}</span>
</h1>
<div mat-dialog-content>
    <ng-template>
        Seguro quiere eliminar el formulario de
        <b>{{ LOCAL_DATA.nombreCompleto }}</b
        >?
    </ng-template>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="doAction()">
        {{ "Eliminar" | translate }}
    </button>
    <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
        {{ "Cancel" | translate }}
    </button>
</div>
